<!-- <app-header #header></app-header>
<app-breadcrumb></app-breadcrumb> -->
<div class="inprogress">
  <img src="../../../assets/images/EarlyPreview.png" height='35px' style="margin-left:'40px'" />

</div>
<div class="pt-3 table  mainclass mb-0">
  <div class="row search_bar w-100 ml-0 mb-0">
    <div class="col-2">
      <span class="h3">List of {{toolTypeName}}</span>
    </div>
    <div class="form-group has-search col-6 pt-3">
      <span class="fa fa-search form-control-feedback pl-3"></span>
      <input type="text" class="form-control pl-5" [(ngModel)]="searchText" [placeholder]="placeholderText"
        (input)="searchResult()">
    </div>

    <div class="row justify-content-end col-3">
      <button class="custom_btn primary_btn_base mr-2 p-2 addbtn" (click)="addTools(toolTypeId,toolTypeName)"><i
          class="fa fa-plus-circle pr-2"></i>Add {{toolTypeName}}</button>
    </div>
  </div>
  <div class="total w-100">
    <table mat-table [dataSource]="dataSource" matSort class="text-center">

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-middle">Tool Name</th>
        <td mat-cell *matCellDef="let row" class="align-middle">
          {{row.name}} </td>
      </ng-container>

      <ng-container matColumnDef="toolTypeId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-middle">Tool Type</th>
        <td mat-cell *matCellDef="let row" class="align-middle">{{row.toolTypeName}} </td>
      </ng-container>

      <ng-container matColumnDef="competency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-middle"> Competency</th>
        <td mat-cell *matCellDef="let row" class="align-middle"> {{row.competencyName}} </td>
      </ng-container>

      <ng-container matColumnDef="subCompetency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-middle"> SubCompetency</th>
        <td mat-cell *matCellDef="let row" class="align-middle">{{row.subCompetencyName}} </td>
      </ng-container>

      <ng-container matColumnDef="sharepointURL">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="align-middle">KMS Url </th>
        <td mat-cell *matCellDef="let row" class="align-middle">{{row.sharepointURL}} </td>
      </ng-container>

      <!-- actions -->
      <ng-container [matColumnDef]="'actions'">
        <th mat-header-cell *matHeaderCellDef class="action" style="text-align: center;"> Actions </th>
        <td mat-cell *matCellDef="let element">
          <button matTooltip="View" mat-icon-button (click)="viewFunction(element.id)">
            <span class="material-symbols-outlined">visibility</span>
          </button>

          <button matTooltip="Copy" mat-icon-button (click)="copyFunction(element.id)">
            <span class="material-symbols-outlined">move_group</span>
          </button>

          <button matTooltip="Edit" mat-icon-button (click)="editFunction(element.id)">
            <span class="material-symbols-outlined">edit</span>
          </button>

          <button matTooltip="Delete" mat-icon-button (click)="deleteTool(element.id)">
            <span class="material-symbols-outlined">delete</span>
          </button>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *ngIf="!dataSource || dataSource.data.length == 0">
        <td class="mat-cell" colspan="4">No data matching the filter </td>
      </tr>
    </table>
  </div>
</div>

<div class="pagination pb-5">
  <button mat-button class="pagination-button" (click)="onPreviousPage()" [disabled]="currentPage === 1">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="page-numbers">
    <button mat-button class="pagination-button" *ngFor="let page of getPageNumbers()"
      [class.active]="page === currentPage" (click)="onPageButtonClick(page)" [ngStyle]="{
        'color': page === currentPage ? 'white' : 'black'
      }">
      {{ page }}
    </button>
  </div>

  <button mat-button class="pagination-button" (click)="onNextPage()" [disabled]="currentPage === getTotalPages()">
    <mat-icon> chevron_right </mat-icon>
  </button>
</div>